import * as React from 'react';
import { Route } from 'react-router-dom';
import { userSchema } from './user';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module Collaborateur
 */
const CollaborateurRoutes = [
    // Route de liste (principale)
    <Route
        key="collaborateurs-list"
        path="collaborateurs"
        element={<Main key="collaborateurs-main" pageConfig={userSchema} />}
    />,
];

export default CollaborateurRoutes;
